export default __webpack_public_path__ + "static/media/google_drive_logo.0b900c10.png";